import { authorizationType } from "#authorization/constants"
import { noAuthorization } from "#authorization/model"
import { detailsType } from "#details/constants"
import { noDetails } from "#details/model"
import { photographType } from "#photographs/constants"
import { noPhotographs } from "#photographs/model"

export const transformAvlPatch = patch => {

    const details = patch.current?.[detailsType] ?? noDetails
    const authz = patch.current?.[authorizationType] ?? noAuthorization
    const photos = patch.current?.[photographType] ?? noPhotographs

    const patched = patch.scope === 'rav' ? { ...patch, [detailsType]: details, [authorizationType]: authz, [photographType]: photos } : patch

    return patched
}